export const storage = {
  hash: '@zoo/hash',
  showPushCount: '@zoo/showPushCount',
  showPushInfoAlert: '@zoo/showPushInfoAlert',
  enabledInitCount: '@zoo/enabledInitCount',
};
